import {
  FLEET_COMPOSER_MODES,
  type FleetComposerMode,
  isFleetComposerMode,
} from "../../../../src/agents/fleet-composer-mode.js";

export type { FleetComposerMode };
export { FLEET_COMPOSER_MODES, isFleetComposerMode };

export function labelForFleetComposerMode(mode: FleetComposerMode): string {
  switch (mode) {
    case "agent":
      return "Agent";
    case "ask":
      return "Ask";
    case "plan":
      return "Plan";
    case "debug":
      return "Debug";
    case "multitask":
      return "Multitask";
    default:
      return "Agent";
  }
}

export function titleForFleetComposerMode(mode: FleetComposerMode): string {
  switch (mode) {
    case "agent":
      return "Agent — talk on this session by default; optional orchestration and projects below.";
    case "ask":
      return "Ask — friendly read-only Q&A on this session (no edits or shell).";
    case "plan":
      return "Plan — explore and draft a plan here; Implement switches to Agent when you are ready.";
    case "debug":
      return "Debug — hypothesis-driven fixes with runtime evidence on this session.";
    case "multitask":
      return "Multitask — fans out with @all to every agent (parallel workers).";
    default:
      return "Composer mode";
  }
}

export type ComposerModeSendOverrides = {
  orchestrateWithAll?: boolean;
  selfImprovement?: boolean;
  createNewProject?: boolean;
};

/** Send-path overrides driven by composer mode (applied before manual checkboxes). */
export function resolveComposerModeSendOptions(mode: FleetComposerMode): ComposerModeSendOverrides {
  if (mode === "multitask") {
    return {
      orchestrateWithAll: true,
      selfImprovement: false,
      createNewProject: false,
    };
  }
  if (mode !== "agent") {
    return {
      orchestrateWithAll: false,
      selfImprovement: false,
      createNewProject: false,
    };
  }
  return {};
}

export function resolveEffectiveChatComposerMode(params: {
  sessionKey: string;
  globalMode: FleetComposerMode;
  bySession?: Record<string, FleetComposerMode>;
  tabComposerMode?: FleetComposerMode;
}): FleetComposerMode {
  if (params.tabComposerMode && isFleetComposerMode(params.tabComposerMode)) {
    return params.tabComposerMode;
  }
  const key = params.sessionKey.trim();
  const override = key ? params.bySession?.[key] : undefined;
  if (override && isFleetComposerMode(override)) {
    return override;
  }
  return params.globalMode;
}
